import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=2a01d0aa&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a01d0aa')) {
      api.createRecord('2a01d0aa', component.options)
    } else {
      api.reload('2a01d0aa', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=2a01d0aa&", function () {
      api.rerender('2a01d0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2D7JXo05vHXns/JS/comp/CurrentYear.vue"
export default component.exports